/** All property page segments — used by Sidebar and PropertyContext for navigation preservation */
export const PROPERTY_PAGE_SEGMENTS = [
  'sessions', 'handovers', 'guests', 'knowledge-base', 'test-chat',
  'automation', 'campaigns', 'feedback', 'analytics', 'team', 'settings', 'billing', 'setup',
] as const;
